import { toRelativeUrl } from '@okta/okta-auth-js';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ context }) => {
    const {
      auth: { oktaAuth },
    } = context;

    if (!(await oktaAuth.isAuthenticated())) {
      const originalUri = toRelativeUrl(window.location.href, window.location.origin);
      await new Promise(() => oktaAuth.signInWithRedirect({ originalUri }));
    }
  },
  component: Outlet,
});
